// @flow weak
import noImg      from "../../../img/no_img.jpg";

const MessageMenu = () => (
  <li className="dropdown messages-menu">
    <a
      href="#"
      className="dropdown-toggle"
      data-toggle="dropdown">
      <i className="glyphicon glyphicon-envelope" />
      <span className="label label-success">
        4
      </span>
    </a>
    <ul className="dropdown-menu">
      <li className="header">
        You have 4 messages
      </li>
      <li>
        <ul className="menu">
          <li>
            <a href="#">
              <div className="pull-left">
                <img
                  src={noImg}
                  className="img-circle"
                  alt="User Image"
                />
              </div>
              <h4>
                  Support Team
              </h4>
              <p>
                Why not buy a new awesome theme?
              </p>
              <small className="pull-right">
                <i className="glyphicon glyphicon-time"></i>
                  5 mins
              </small>
            </a>
          </li>
          <li>
            <a href="#">
              <div className="pull-left">
                <img
                  src={noImg}
                  className="img-circle"
                  alt="user image"
                />
              </div>
              <h4>
                  Director Design Team
              </h4>
              <p>
                Why not buy a new awesome theme?
              </p>
              <small className="pull-right">
                <i className="glyphicon glyphicon-time" />
                  2 hours
              </small>
            </a>
          </li>
          <li>
            <a href="#">
              <div className="pull-left">
                <img
                  src={noImg}
                  className="img-circle"
                  alt="user image"
                />
              </div>
              <h4>
                Developers
              </h4>
              <p>Why not buy a new awesome theme?</p>
              <small className="pull-right">
                <i className="glyphicon glyphicon-time" />
                  Today
              </small>
            </a>
          </li>
          <li>
            <a href="#">
              <div className="pull-left">
                <img
                  src={noImg}
                  className="img-circle"
                  alt="user image"
                />
              </div>
              <h4>
                  Sales Department
              </h4>
              <p>
                Why not buy a new awesome theme?
              </p>
              <small className="pull-right">
                <i className="glyphicon glyphicon-time" />
                  Yesterday
              </small>
            </a>
          </li>
          <li>
            <a href="#">
              <div className="pull-left">
                <img
                  src={noImg}
                  className="img-circle"
                  alt="user image"
                />
              </div>
              <h4>
                Reviewers
              </h4>
              <p>
                Why not buy a new awesome theme?
              </p>
              <small className="pull-right">
                <i className="glyphicon glyphicon-time" />
                  2 days
              </small>
            </a>
          </li>
        </ul>
      </li>
      <li className="footer">
        <a href="#">
          See All Messages
        </a>
      </li>
    </ul>
  </li>
);

export default MessageMenu;



// WEBPACK FOOTER //
// ./src/app/components/header/messageMenu/MessageMenu.js